import { cn } from "@/utils/utils";
import React from "react";
import Text, { TextVariant } from "@/components/ui/text";

interface HorizontalLineProps {
  className?: string;
}

const HorizontalLine: React.FC<HorizontalLineProps> = ({ className }) => {
  return <hr className={cn("w-full border-0 h-0.5 items-center", className)} />;
};

interface Props {
  text: string;
  thick?: boolean;
  textVariant?: TextVariant;
}

const ChatSeparator: React.FC<Props> = ({
  text,
  thick = false,
  textVariant = "smBodySecondary"
}) => {
  return (
    <div
      data-test="chat-separator"
      className={cn(
        "flex flex-row w-full items-center",
        thick ? "bg-chat-message-me justify-center" : "px-5"
      )}
    >
      {!thick && (
        <HorizontalLine className="flex-1 bg-gradient-to-r from-transparent to-secondary opacity-20" />
      )}
      <Text
        as="span"
        variant={textVariant}
        className="mx-2 line-clamp-1 whitespace-nowrap leading-7 flex-shrink-0"
      >
        {text}
      </Text>
      {!thick && (
        <HorizontalLine className="flex-1 bg-gradient-to-r from-secondary to-transparent opacity-20" />
      )}
    </div>
  );
};

export default ChatSeparator;
